/** Success beep + vibration, mirroring Scandit's playSoundOnScan behavior. */

let audioCtx: AudioContext | null = null;

export function beep(): void {
  try {
    audioCtx ??= new AudioContext();
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.frequency.value = 1800;
    osc.type = "square";
    gain.gain.setValueAtTime(0.08, audioCtx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.12);
    osc.connect(gain).connect(audioCtx.destination);
    osc.start();
    osc.stop(audioCtx.currentTime + 0.12);
  } catch {
    // Audio is best-effort; never break scanning over it.
  }
}

export function vibrate(): void {
  navigator.vibrate?.(60);
}
